<template>
  <div>
    <header-bar>
      著作権スプリット
    </header-bar>
    <div
      class="page-block">
      <div class="page-block__inner">
        <div class="approval-content">
          <div>
            <strong>著作権スプリットへの招待を承認しました。</strong><br>
            <br>
            当リリースに関わるすべてのゲストが承認するまで、<br>
            著作権スプリットの設定は保留されます。
          </div>
          <div class="list-container">
            <ul>
              <li>すべてのゲストが承認した場合、著作権スプリットの開始をお知らせします</li>
              <li>
                いずれかのゲストがキャンセルすると、著作権スプリットは開始されません。<br>
                その場合、著作権スプリットがキャンセルされた旨をメールにてお知らせします。
              </li>
            </ul>
          </div>
          <router-link
            :to="{name: 'index'}"
            class="c-btn">
            トップへ
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../../HeaderBar'

export default {
  name: 'ApprovalCompleted',
  components: {
    HeaderBar,
  },
}
</script>

<style scoped>
.approval-content {
  text-align: center;
  font-weight: 400;
  padding: 10px 30px;
}
.list-container{
  width: fit-content;
  text-align: start;
  margin: auto;
  padding: 14px 0;
}
.list-container ul, .list-container li{
  list-style: unset !important;
}
</style>
